module.exports = __webpack_public_path__ + "static/media/01.Foreign Tour.880113d5.JPG";